const mergeEvents = require('./mergeEvents');

module.exports = function negotiateMergeOrInsertEvents(event, events, index) {
    var compareIndex = Math.min(index, events.length-1);
    var spliceIndex = Math.min(index, events.length);
    var comparedEvent = events[compareIndex] || {};
    if(event.name === undefined || event.name !== comparedEvent.name) {
        events.splice(spliceIndex, 0, event);
    } else {
        mergeEvents(event, comparedEvent);
    }
};
